import { defineMessages, IntlShape } from "react-intl";

const validationMessages = defineMessages({
  errorTickerPattern: {
    id: "formValidation.errorTickerPattern",
    defaultMessage: "Invalid ticker",
  },
  errorMaxLength: {
    id: "formValidation.errorMaxLength",
    defaultMessage: "Maximum length is {max} characters",
  },
  errorRequiredField: {
    id: "formValidation.errorRequiredField",
    defaultMessage: "This field is required",
  },
});

export const TICKER_REGEX_PATTERN = /^[a-zA-Z0-9_]+$/;
export const TICKER_MAX_LENGTH = 30;

export const tickerHookFormValidation = (
  intl: IntlShape,
  maxLength: number = TICKER_MAX_LENGTH
) => ({
  required: {
    value: true,
    message: intl.formatMessage(validationMessages.errorRequiredField),
  },
  pattern: {
    value: TICKER_REGEX_PATTERN,
    message: intl.formatMessage(validationMessages.errorTickerPattern),
  },
  maxLength: {
    value: maxLength,
    message: intl.formatMessage(validationMessages.errorMaxLength, { max: maxLength }),
  },
});
